import { tss } from 'tss-react/mui';

const useStyles = tss
  .withParams<{
    backgroundColor: string | undefined;
  }>()
  .create(({ theme, backgroundColor }) => {
    const contentColor = theme.vars.palette.common.black;
    return {
      environmentAlert: {
        alignItems: 'center',
        backgroundColor,
        color: contentColor,
        display: 'flex',
        justifyContent: 'space-between',
        padding: '.025rem .5rem',
        whiteSpace: 'pre-wrap',
        width: '100%'
      },
      environmentAlertCancelIcon: {
        color: `${contentColor}!important`
      }
    };
  });

export default useStyles;
